import { combineReducers } from 'redux';
import headerReducer from '@gerenciatd/next.app-controller.reducers-sagas.header-reducer-r';
import mainReducer from '@gerenciatd/next.app-controller.reducers-sagas.main-reducer-r';
import modalsReducer from '@gerenciatd/next.app-controller.reducers-sagas.modals-reducer';
import publicReducer from '@/reducers/public';

const rootReducers = () =>
  combineReducers({
    header: headerReducer,
    main: mainReducer,
    modals: modalsReducer,
    public: publicReducer,
  });

export default rootReducers;
